@if (root() && isVisible()) {
    <div class="layout-menuitem-root-text">{{ item().label }}</div>
}
@if ((!hasRouterLink() || hasChildren()) && isVisible()) {
    <a
        [attr.href]="item().url"
        (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()"
        [ngClass]="item().class"
        [attr.target]="item().target"
        tabindex="0"
        pRipple
        [pTooltip]="item().label"
        [tooltipDisabled]="!(isCompact() && !isActive() && root())"
    >
        <i [ngClass]="item().icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text label-small text-inherit">{{ item().label }}</span>
        @if (hasChildren()) {
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
        }
    </a>
}
@if (hasRouterLink() && !hasChildren() && isVisible()) {
    <a
        (click)="itemClick($event)"
        (mouseenter)="onMouseEnter()"
        [ngClass]="item().class"
        [routerLink]="item().routerLink"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="item().routerLinkActiveOptions || { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
        [fragment]="item().fragment"
        [queryParamsHandling]="item().queryParamsHandling"
        [preserveFragment]="item().preserveFragment"
        [skipLocationChange]="item().skipLocationChange"
        [replaceUrl]="item().replaceUrl"
        [state]="item().state"
        [queryParams]="item().queryParams"
        [attr.target]="item().target"
        tabindex="0"
        [pTooltip]="item().label"
        [tooltipDisabled]="!(isCompact() && !isActive() && root())"
    >
        <i [ngClass]="item().icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text label-small text-inherit">{{ item().label }}</span>
    </a>
}
@if (hasChildren() && isVisible()) {
    <ul [class.layout-root-submenulist]="root()">
        @for (child of item().items; track child?.label || $index) {
            <li app-menuitem [item]="child" [root]="false" [index]="$index" [parentPath]="fullPath()" [class]="child['badgeClass']"></li>
        }
    </ul>
}
